import { render, staticRenderFns } from "./ApplicantOnBehalfAuthorize.vue?vue&type=template&id=739a6511&scoped=true&"
import script from "./ApplicantOnBehalfAuthorize.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnBehalfAuthorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739a6511",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
